export const LANGS = ['es', 'en', 'fr', 'ca', 'eu', 'it'] as const;
export type Lang = typeof LANGS[number];

export enum EnumLang {
  es = 'es',
  en = 'en',
  fr = 'fr',
  ca = 'ca',
  eu = 'eu',
  it = 'it'
}

export const LANGS_V2 = ['es', 'en', 'fr', 'ca', 'pv', 'it'] as const;
export type Lang_V2 = typeof LANGS_V2[number];

export const COUNTRY_PREFIX = 'nombre_pais';

export interface LangConfigManuales {
  code: Lang;
  label: string;
}
export const LANG_CONFIG_MANUALES: LangConfigManuales[] = [
  { code: "es", label: "español" },
  { code: "en", label: "ingles" },
  { code: "fr", label: "frances" },
  { code: "ca", label: "catalan" },
  { code: "eu", label: "euskera" },
  { code: "it", label: "italiano" }
];